// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__yeC9a","primary":"Button_primary__fp29r","ghost":"Button_ghost__6Jxm4","blue":"Button_blue__26dqR","sm":"Button_sm__NAhkI"};